import React from 'react'
import logoSvg from '../assets/logo.svg'

const Logo: React.FC = () => {
  return (
    <h1 className="text-xl font-bold text-gray-900 flex items-center">
      <img
        src={logoSvg}
        style={{
          width: '30px',
        }}
      />
      TrackIEP
    </h1>
  )
}

export default Logo
